export default "__VITE_ASSET__O$MFPQRr__"